import { Component, OnInit, ViewChild, Input, OnChanges } from '@angular/core';
import Vimeo from '@vimeo/player';

@Component({
  selector: 'app-video-player',
  templateUrl: './video-player.component.html',
  styleUrl: './video-player.component.scss',
  imports: [],
})
export class VideoPlayerComponent implements OnInit, OnChanges {
  @Input() video;
  @ViewChild('playerContainer', { static: true }) playerContainer;
  private player: Vimeo;
  showVideo = true;

  ngOnInit(): void {
    const options = {
      id: this.video,
      // width: 640,
      // loop: true,
    };
    this.player = new Vimeo(this.playerContainer.nativeElement, options);
  }

  ngOnChanges(changes) {
    if (changes.video.currentValue && this.player) {
      this.player.loadVideo(changes.video.currentValue).then(() => {
        console.log(`video ${changes.video.currentValue} loaded`);
      });
    }
  }
}
